import type { LangCopy } from '@CS/components/TranslationProvider/types';
import { type PopupProps, Popup } from '@CS/components/Popups';
import LocalizedImage from '@CS/components/LocalizedImage';
import type { Quiz } from '@/services/api/types';
import { useTranslation } from '@CS/hooks';
import Button from '@CS/components/Button';
import CSS from './Wrong.module.css';
import Images from '@/assets/images';
import { useState } from 'react';
import Content from './content';

type WrongProps = PopupProps & {
  last?: boolean;
  quiz: Quiz;
};

export const Wrong = ({ quiz, last, ...props }: WrongProps) => {
  const { title, description, next, complete } = useTranslation(Content);
  const { explanation } = useTranslation<{ explanation: LangCopy }>(
    quiz.translations as { explanation: LangCopy }
  );

  const [close, setClose] = useState(false);
  const onClick = () => setClose(true);
  const button = last && complete || next;

  return (
    <Popup
      hideClose
      {...props}
      opacity="0"
      close={close}
      className={CSS.wrongContainer}
    >
      <LocalizedImage name="Oops!" images={Images.Wrong} />

      <div className={CSS.wrongContent}>
        <h4>{title}</h4>
        <span>{explanation ?? description}</span>
        <Button text={button} onClick={onClick} />
      </div>
    </Popup>
  );
};
